module.exports = __webpack_public_path__ + "img/file-user.23cd1b48.svg";